var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPoints(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 1.9C12.9 1.9 16.1 5.1 16.1 9C16.1 12.9 12.9 16.1 9 16.1C5.1 16.1 1.9 12.9 1.9 9C1.9 5.1 5.1 1.9 9 1.9ZM9 0.5C4.3 0.5 0.5 4.3 0.5 9C0.5 13.7 4.3 17.5 9 17.5C13.7 17.5 17.5 13.7 17.5 9C17.5 4.3 13.7 0.5 9 0.5Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.00045 7.2999L9.30045 7.7999C9.50045 8.2999 10.0005 8.5999 10.5005 8.6999L11.1005 8.7999L10.7005 9.1999C10.3005 9.5999 10.1005 10.0999 10.2005 10.5999L10.3005 11.1999L9.80045 10.8999C9.60045 10.7999 9.30045 10.6999 9.10045 10.6999C8.80045 10.6999 8.60045 10.7999 8.40045 10.8999L7.90045 11.1999L8.00045 10.5999C8.10045 10.0999 7.90045 9.4999 7.50045 9.1999L7.00045 8.7999L7.60045 8.6999C8.10045 8.5999 8.60045 8.2999 8.80045 7.7999L9.00045 7.2999ZM9.00045 4.3999C8.90045 4.3999 8.90045 4.3999 8.80045 4.4999L7.50045 7.1999C7.50045 7.2999 7.40045 7.2999 7.30045 7.2999L4.30045 7.6999C4.10045 7.6999 4.10045 7.8999 4.20045 8.0999L6.30045 10.1999C6.30045 10.1999 6.40045 10.2999 6.40045 10.3999L5.90045 13.3999C5.90045 13.4999 6.00045 13.5999 6.10045 13.5999H6.20045L8.90045 12.1999H9.00045H9.10045L11.8005 13.5999H11.9005C12.0005 13.5999 12.1005 13.4999 12.1005 13.3999L11.6005 10.3999C11.6005 10.2999 11.6005 10.2999 11.7005 10.1999L13.8005 8.0999C13.9005 7.9999 13.9005 7.7999 13.7005 7.6999L10.7005 7.2999C10.6005 7.2999 10.6005 7.1999 10.5005 7.1999L9.20045 4.4999C9.10045 4.3999 9.10045 4.3999 9.00045 4.3999Z",
    fill: "#525252"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoints);
export default __webpack_public_path__ + "static/media/points.0f99079808250f63a257a1a2b478fe99.svg";
export { ForwardRef as ReactComponent };